module.exports = __webpack_public_path__ + "static/media/hanley-calibration.7ad32faf.jpg";